import { render, staticRenderFns } from "./TaskTeaser.vue?vue&type=template&id=4a978b1a&scoped=true"
import script from "./TaskTeaser.vue?vue&type=script&lang=js"
export * from "./TaskTeaser.vue?vue&type=script&lang=js"
import style0 from "./TaskTeaser.vue?vue&type=style&index=0&id=4a978b1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a978b1a",
  null
  
)

export default component.exports